export default __webpack_public_path__ + "static/media/cp_geo_ec.30a0a300.svg";